var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgC2SlidingGateClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65 22v4H11v-4H5v33h66V22h-6zm0 29H11V30h54v21zm-5-13h-4v-4h4v4zm-8 0h-4v-4h4v4zm-8 0h-4v-4h4v4zm-8 0h-4v-4h4v4zm-8 0h-4v-4h4v4zm-8 0h-4v-4h4v4z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/C2_Sliding_gate_close.405f5449.svg";
export { SvgC2SlidingGateClose as ReactComponent };